import { render } from "./ModalDocumentError.vue?vue&type=template&id=144b132f&scoped=true"
import script from "./ModalDocumentError.vue?vue&type=script&lang=js"
export * from "./ModalDocumentError.vue?vue&type=script&lang=js"

import "./ModalDocumentError.vue?vue&type=style&index=0&id=144b132f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144b132f"]])

export default __exports__